var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alert-container" }, [
    _vm.filteredAlerts.length
      ? _c(
          "section",
          { staticClass: "alert-list" },
          _vm._l(_vm.filteredAlerts, function(alert) {
            return _c(
              "div",
              { key: alert.id },
              [
                _c(
                  "transition-group",
                  { attrs: { name: "fade", appear: "" } },
                  [
                    _vm.isCC
                      ? _c("CCAlert", {
                          key: alert.id,
                          attrs: { alert: alert }
                        })
                      : _vm.isPMB
                        ? _c("PMBAlert", {
                            key: alert.id,
                            attrs: { alert: alert }
                          })
                        : _vm.isDAT
                          ? _c("DAlert", {
                              key: alert.id,
                              attrs: { alert: alert }
                            })
                          : _vm.isOA
                            ? _c("OAAlert", {
                                key: alert.id,
                                attrs: { alert: alert }
                              })
                            : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          })
        )
      : _c("div", { staticClass: "no-alerts-message" }, [
          _vm._v("\n        No " + _vm._s(_vm.status) + " alerts\n    ")
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d033255", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d033255","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alerts/containers/AlertList.vue
// module id = null
// module chunks = 